import { render, staticRenderFns } from "./testingRadioButton.vue?vue&type=template&id=b2987382&"
import script from "./testingRadioButton.vue?vue&type=script&lang=js&"
export * from "./testingRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports